import { Calculator } from "lucide-react";
import PrazoCalculatorForm from "@/components/PrazoCalculatorForm";

import { Dica } from "@/components/Dica";
// Aba própria da Calculadora de Prazos (Lote 44, pedido do Robson) — desktop: item de
// menu logo abaixo de "Calendário"; mobile: dentro de "Mais". A calculadora continua
// também acessível de dentro de "Para validar" (modal `PrazoCalculator.jsx`) — os dois
// pontos de entrada reaproveitam o mesmo formulário (`PrazoCalculatorForm.jsx`).
export default function PrazoCalculatorPage() {
  return (
    <div className="p-4 md:p-8 lg:p-12 max-w-2xl mx-auto pb-24 md:pb-8">
      <header className="mb-6">
        <div className="text-[11px] font-bold tracking-[0.28em] uppercase text-emerald-brand mb-2">
          Calculadora
        </div>
        <h1 className="font-display text-3xl font-bold text-stone-900 flex items-center gap-3">
          <Calculator className="w-7 h-7 text-emerald-brand" strokeWidth={1.75} />
          Calculadora de prazos
        </h1>
        <Dica className="text-sm text-stone-500 mt-2 max-w-lg">{`Conta prazos trabalhistas e cíveis em dias úteis ou corridos, considerando feriados nacionais e o recesso forense — a partir da data de disponibilização, como no diário oficial.`}</Dica>
      </header>

      <div className="bg-white border border-stone-200 rounded-md p-5">
        <PrazoCalculatorForm />
      </div>
    </div>
  );
}
